/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 **/

import {
  getUserServicesUtils,
  createSeedkit,
} from '@seedkit/core';
import { markRaw, defineAsyncComponent } from 'vue';
import { HttpClient } from 'app/api/http-client';
import { securityWorker } from 'app/api/security';
import { customFetch } from 'app/api/custom-fetch';
import RootComponent from 'app/src/app';
import createRouter from 'app/src/app/providers/router';
import createStore from 'app/src/app/providers/pinia';

import pluginsList from 'app/src/app/plugins';


import layoutsConfig from 'app/theme/layouts/config';


// import {
//   RrNavbar,
//   RrFooter,
// } from '@seedkit/vue/widgets';

import { RrNotFoundPage as NotFoundComponent } from '@seedkit/vue/widgets';

export default async function (createAppFn, seedkitUserOptions) {
  const app = createAppFn(RootComponent);

  
  app.config.globalProperties.$services = await getUserServicesUtils();

  const store = typeof createStore === 'function'
    ? await createStore()
    : createStore;
  const router = markRaw(
    typeof createRouter === 'function'
      ? await createRouter({ store })
      : createRouter,
  );
  router.addRoute({
    name: 'PageNotFound',
    path: '/:pathMatch(.*)*',
    component: NotFoundComponent,
    meta: {
      layout: 'DefaultLayout',
      guard: true
    },
  });
  store.use(({ store }) => { store.router = router });
  
  const apis = await Promise.all([
    { name: 'Auth', fn: await import('app/api/Auth') },
    { name: 'Admin', fn: await import('app/api/Admin') },
    { name: 'Gamification', fn: await import('app/api/Gamification') },
    { name: 'AddressCollections', fn: await import('app/api/AddressCollections') },
    { name: 'VolunteerCertificates', fn: await import('app/api/VolunteerCertificates') },
    { name: 'Files', fn: await import('app/api/Files') },
    { name: 'Users', fn: await import('app/api/Users') },
    { name: 'Roles', fn: await import('app/api/Roles') },
    { name: 'Modules', fn: await import('app/api/Modules') },
    { name: 'Operations', fn: await import('app/api/Operations') },
    { name: 'UserGroups', fn: await import('app/api/UserGroups') },
    { name: 'UserConfiguration', fn: await import('app/api/UserConfiguration') },
    { name: 'Namespaces', fn: await import('app/api/Namespaces') },
    { name: 'Notifications', fn: await import('app/api/Notifications') },
    { name: 'SecuredEntities', fn: await import('app/api/SecuredEntities') },
    { name: 'AuthorizationAttributes', fn: await import('app/api/AuthorizationAttributes') },
    { name: 'DynamicDirectories', fn: await import('app/api/DynamicDirectories') },
    { name: 'Policies', fn: await import('app/api/Policies') },
    { name: 'DynamicTypes', fn: await import('app/api/DynamicTypes') },
    { name: 'JobManagement', fn: await import('app/api/JobManagement') },
    { name: 'GoodDeeds', fn: await import('app/api/GoodDeeds') },
    { name: 'Documents', fn: await import('app/api/Documents') },
    { name: 'Presentation', fn: await import('app/api/Presentation') }
  ]);
  
  
  
  
  const modules = await Promise.all([ {
    name: 'administration', fn: await import('@seedkit/vue-administration-module'), config: {} }, {
    name: 'dynamic-types', fn: await import('@seedkit/vue-dynamic-types-module'), config: {} }, {
    name: 'dynamic-directory', fn: await import('@seedkit/vue-dynamic-directory-module'), config: {} }, {
    name: 'system-notifications', fn: await import('@seedkit/vue-system-notifications-module'), config: {} }, {
    name: 'job-managment', fn: await import('@seedkit/vue-job-managment-module'), config: {} }, {
    name: 'files', fn: await import('@seedkit/vue-files-module'), config: {} }, {
    name: 'about', fn: await import('app/modules/about'), config: {} }, {
    name: 'advertising', fn: await import('app/modules/advertising'), config: {} }, {
    name: 'analytics', fn: await import('app/modules/analytics'), config: {} }, {
    name: 'calendar', fn: await import('app/modules/calendar'), config: {} }, {
    name: 'content', fn: await import('app/modules/content'), config: {} }, {
    name: 'donation-registry', fn: await import('app/modules/donation-registry'), config: {} }, {
    name: 'events', fn: await import('app/modules/events'), config: {} }, {
    name: 'exercises', fn: await import('app/modules/exercises'), config: {} }, {
    name: 'gamification', fn: await import('app/modules/gamification'), config: {} }, {
    name: 'good-deeds-board', fn: await import('app/modules/good-deeds-board'), config: {} }, {
    name: 'grants', fn: await import('app/modules/grants'), config: {} }, {
    name: 'measures', fn: await import('app/modules/measures'), config: {} }, {
    name: 'presentation', fn: await import('app/modules/presentation'), config: {} }, {
    name: 'press-center', fn: await import('app/modules/press-center'), config: {} }, {
    name: 'tasks', fn: await import('app/modules/tasks'), config: {} }, {
    name: 'technical-support', fn: await import('app/modules/technical-support'), config: {} }, {
    name: 'wards-and-volunteers', fn: await import('app/modules/wards-and-volunteers'), config: {} }
  ]);
  
  
  const http = new HttpClient({
    baseUrl: 'https://lk.fondpokolenie.ru',
    securityWorker,
    customFetch,
  });
  

  const theme = {
    header: defineAsyncComponent(() => import('app/theme/header.vue')),
    page: defineAsyncComponent(() => import('app/theme/page.vue')),
    listPage: defineAsyncComponent(() => import('app/theme/list-page.vue')),
    modal: defineAsyncComponent(() => import('app/theme/modal.vue')), 
  };
  const seedkit = createSeedkit({
    app,
    store,
    router,
    http,
    modules: modules || [],
    apis,
    theme,layoutsConfig,
    plugins: {
      list: pluginsList,
      allowed: [ 'notification', 'modal', 'apexcharts' ]
    },
    appConfig: {
      title: 'Фонд "Поколение"',description: 'Панель управления',
      logo: "/images/logo.svg",
    },
  });

  return {
    app,
    router,
    seedkit,
    store,
  };
}
